import Vue from "vue";
import Vuex from "vuex";
//import Resoluciones from "@/data/resoluciones_dummy";
import resolucionesLocal from "@/data/resoluciones";
import { getResoluciones } from "../api/resoluciones";

Vue.use(Vuex);

function filtrarCeros(tipoResoluciones) {
  const aux = {};
  Object.keys(tipoResoluciones).forEach((key) => {
    if (tipoResoluciones[key] !== 0) aux[key] = tipoResoluciones[key];
  });

  return aux;
}

function historico(resoluciones) {
  const resolucionesPorMes = resoluciones.reduce((acc, cur) => {
    cur.resolucionesPorMes.forEach(item => {
      const aux = acc.find(x => x.mes == item.mes)
      if (aux)
        aux.cant += item.cant;
      else
        acc.push({ mes: item.mes, cant: item.cant });
    })

    return acc;
  }, []);

  const totalResoluciones = resoluciones.reduce((acc, cur) => acc += cur.totalResoluciones, 0);
  const casosViolenciaGenero = resoluciones.reduce((acc, cur) => acc += cur.casosViolenciaGenero, 0);

  const tipoResoluciones = resoluciones.reduce((acc, cur) => {
    Object.keys(cur.tipoResoluciones).forEach(key => {
      if (key in acc)
        acc[key] += cur.tipoResoluciones[key];
      else
        acc[key] = cur.tipoResoluciones[key];
    })

    return acc;
  }, {});

  const rankingArticulosTotales = resoluciones.reduce((acc, cur) => {
    cur.rankingArticulos.forEach(item => {
      const aux = acc.find(x => x.articulo == item.articulo)
      if (aux) {
        aux.cant += item.cant;
        if (item.cantConductas > aux.cantConductas) {
          aux.cantConductas = item.cantConductas;
          aux.conductaMasComun = item.conductaMasComun;
        }
      }
      else {
        acc.push({ articulo: item.articulo, cant: item.cant, conductaMasComun: item.conductaMasComun, cantConductas: item.cantConductas });
      }
    })

    return acc;
  }, []);

  const rankingArticulos = rankingArticulosTotales.sort((a, b) => b.cant - a.cant).slice(0, 5);

  return {
    resolucionesPorMes,
    totalResoluciones,
    casosViolenciaGenero,
    tipoResoluciones,
    rankingArticulos
  }
}

export default new Vuex.Store({
  state: {
    datosDesactualizados: false,
    year: null,
    title: "",
    resoluciones: [],
    resolucionActual: null,
    links: {
      repositorioDatos:
        "https://docs.google.com/spreadsheets/d/1uAi-Yfq-rJl_cqQaVe9Fv1rLlBJcmEtDpUB0NTOrLAs",
      documentoLenguaje:
        "https://drive.google.com/file/d/17lZJbD3F9ArHkZUHfDhFZqWw9SQO2cph/preview",
      manualProcedimientos:
        "https://drive.google.com/file/d/0B-HNNg3Su-HFYW9NR1RVZjhkRm1xTEs2VmMxbkFiUERVOTM4/preview",
      documentoPlanificacion:
        "https://drive.google.com/file/d/1ewcsYz1CEe0QxaM3LEK0wA7uK0hjcZUQ/preview",
      ubicacion:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3283.7704032052957!2d-58.381226485052096!3d-34.609966865335245!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bccad11236789b%3A0x659b90a44defa087!2sTacuar%C3%AD%20138%2C%20C1071%20AAD%2C%20Buenos%20Aires!5e0!3m2!1sen!2sar!4v1599769568879!5m2!1sen!2sar",
      twitter: "https://twitter.com/jpcyf10?ref_src=twsrc%5Etfw",
    },
  },
  mutations: {
    SET_YEAR(state, year) {
      state.year = year;
      state.resolucionActual = state.resoluciones.find(
        (x) => x.year == state.year
      );
    },
    SET_TITLE(state, title) {
      state.title = title;
    },
    SET_RESOLUCIONES(state, resoluciones) {
      state.resoluciones = resoluciones;
    },
    SET_DATOS_DESACTUALIZADOS(state, desactualizado) {
      state.datosDesactualizados = desactualizado;
    },
    SET_HISTORICO(state) {
      //console.log(historico(state.resoluciones));
      state.resolucionActual = historico(state.resoluciones);
    }
  },
  actions: {
    getResoluciones({ commit }) {
      return getResoluciones()
        .then((data) => {
          commit("SET_RESOLUCIONES", data.resoluciones);
          //commit("SET_YEAR", state.year);
          commit("SET_HISTORICO");
          commit("SET_DATOS_DESACTUALIZADOS", false);
        })
        .catch((error) => {
          // Si algo falla, carga los datos locales.
          console.error(error);

          commit("SET_RESOLUCIONES", resolucionesLocal);
          // commit("SET_YEAR", state.year);
          commit("SET_HISTORICO");
          commit("SET_DATOS_DESACTUALIZADOS", true);
        });
    },
  },
  getters: {
    getResolucionesMes: (state) => (semestre) => {
      if (!state.resolucionActual) return null;

      const cantMes = state.resolucionActual.resolucionesPorMes.map(
        (x) => x.cant
      );

      const resolucionesSemestre =
        semestre === 1 ? cantMes.slice(0, 6) : cantMes.slice(6);

      return resolucionesSemestre;
    },
    getTiposLabel: (state) => {
      if (!state.resolucionActual) return null;

      const tipoResolucionConValor = filtrarCeros(
        state.resolucionActual.tipoResoluciones
      );
      const keys = Object.keys(tipoResolucionConValor);
      return keys;
      //return keys.map((x) => `${x} (${tipoResolucionConValor[x]})`);
    },
    getTiposValues: (state) => {
      if (!state.resolucionActual) return null;

      const tipoResolucionConValor = filtrarCeros(
        state.resolucionActual.tipoResoluciones
      );
      return Object.values(tipoResolucionConValor);
    },
    getTotalResoluciones: (state) => {
      if (!state.resolucionActual) return null;
      return state.resolucionActual.totalResoluciones;
    },
    getCasosViolenciaGenero: (state) => {
      if (!state.resolucionActual) return null;
      return state.resolucionActual.casosViolenciaGenero;
    },
    getPorcentajeViolenciaGenero: (state) => {
      if (!state.resolucionActual) return null;

      let porcentaje =
        (state.resolucionActual.casosViolenciaGenero /
          state.resolucionActual.totalResoluciones) *
        100;

      porcentaje = Math.round(porcentaje * 100) / 100;
      return Number.isNaN(porcentaje) ? 0 : porcentaje;
    },
    getFaltas: (state) => {
      if (!state.resolucionActual) return null;
      if (!("faltas" in state.resolucionActual.tipoResoluciones)) return 0;
      return state.resolucionActual.tipoResoluciones["faltas"];
    },
    getPenal: (state) => {
      if (!state.resolucionActual) return null;
      if (!("penal" in state.resolucionActual.tipoResoluciones)) return 0;
      return state.resolucionActual.tipoResoluciones["penal"];
    },
    getContravencional: (state) => {
      if (!state.resolucionActual) return null;
      if (!("contravencional" in state.resolucionActual.tipoResoluciones))
        return 0;
      return state.resolucionActual.tipoResoluciones["contravencional"];
    },
    getRankingArticulos: (state) => {
      if (!state.resolucionActual) return [];
      return state.resolucionActual.rankingArticulos.filter((x) => x.cant > 0);
    },
  },
  modules: {},
});
